import { useContext } from 'react';
import { VitalTestContext } from '../contexts/VitalTestContext';

export const useVitalTests = () => {
  const context = useContext(VitalTestContext);
  
  if (!context) {
    throw new Error('useVitalTests must be used within a VitalTestProvider');
  }
  
  return context;
};
